import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _CreditStructure } from '../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectCreditStructureConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CreditStructure)
    const [id, setID] = useState(idSelector);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector);
        }
    }, [idSelector])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getLista = () => {
        instance.creditStrucutreConstants(null).then(
            (resp: any) => {
                setLista(resp);
                console.log(resp)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <>
            <label>{label ? label : 'Estructura'}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null
                setValue(value)
            }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Property} value={item.DataBeanProperties.Property} >{item.DataBeanProperties.Value}</option>
                        )
                    })
                }
            </select>
        </>
    )
}
